import { Link, useSearchParams } from 'react-router-dom';
import { getAssetPath } from '@utils/brandHelper';
import { useBackgroundRotation } from '@brandscripts/useBackgroundRotation';
import { CheckCircle, XCircle, Mail } from 'lucide-react';
import { useT } from '@/i18n';
import './VerifyEmail.css';

// Icon and type config (translations handled separately)
const STATUS_ICONS = {
  verified: { icon: CheckCircle, type: 'success', showLogin: true },
  'already-verified': { icon: CheckCircle, type: 'info', showLogin: true },
  invalid: { icon: XCircle, type: 'error', showLogin: true },
  pending: { icon: Mail, type: 'pending', showLogin: false },
};

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || 'pending';
  const backgroundImage = useBackgroundRotation();
  const t = useT();

  const iconConfig = STATUS_ICONS[status] || STATUS_ICONS.pending;
  const IconComponent = iconConfig.icon;

  // Get translation key based on status
  const statusKey = status === 'already-verified' ? 'already_verified' : status;

  return (
    <div
      className="verify-email-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <img src={getAssetPath('logo.webp')} alt="Logo" className="verify-email-logo" />

      <div className={`verify-email-card verify-email-card--${iconConfig.type}`}>
        <div className="verify-email-icon">
          <IconComponent size={64} />
        </div>

        <h1 className="verify-email-title">{t(`verify.${statusKey}_title`)}</h1>
        <p className="verify-email-message">{t(`verify.${statusKey}_message`)}</p>

        {status === 'pending' && (
          <div className="verify-email-tips">
            <p>{t('verify.didnt_receive')}</p>
            <ul>
              <li>{t('verify.tip_spam')}</li>
              <li>{t('verify.tip_correct_email')}</li>
              <li>{t('verify.tip_wait')}</li>
            </ul>
          </div>
        )}

        <div className="verify-email-actions">
          {iconConfig.showLogin && (
            <Link to="/" className="button button-cta">
              {t('verify.go_to_login')}
            </Link>
          )}

          {status === 'pending' && (
            <Link to="/" className="button button-secondary">
              {t('verify.back_to_login')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
